<template>
  <circle-button
    icon="mdi-file-excel"
    @click="$emit('click')"
    color="success"
    :loading="loading"
    :small="small"
    :tooltip="$t('export_excel')"
  ></circle-button>
</template>

<script>
export default {
  name: "GlobalButtonExcel",
  props: {
    color: {
      type: String,
      default: "white",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    }
  },
};
</script>
